var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "gg-card",
    [
      _c(
        "gg-card-text",
        {
          staticClass: "pa-3"
        },
        [
          _c(
            "div",
            {
              staticClass: "d-flex flex-wrap align-center mb-3"
            },
            [
              _c(
                "h2",
                {
                  staticClass: "vds-metrics__heading body-1 mr-auto"
                },
                [
                  _c(
                    "v-icon",
                    {
                      staticClass: "pb-1",
                      attrs: {
                        size: "24",
                        color: "primary",
                        "aria-hidden": "true"
                      }
                    },
                    [_vm._v("mdi-chart-line")]
                  ),
                  _c(
                    "span",
                    {
                      staticClass: "ml-2"
                    },
                    [_vm._v("Metrics")]
                  )
                ],
                1
              ),
              _c(
                "v-btn-toggle",
                {
                  staticClass: "vds-metrics__range",
                  attrs: {
                    mandatory: "",
                    dense: "",
                    role: "group",
                    "aria-label": "Metrics time range"
                  },
                  on: {
                    change: _vm.loadMetrics
                  },
                  model: {
                    value: _vm.range,
                    callback: function callback($$v) {
                      _vm.range = $$v
                    },
                    expression: "range"
                  }
                },
                _vm._l(_vm.ranges, function(r) {
                  return _c(
                    "v-btn",
                    {
                      key: r,
                      attrs: {
                        value: r,
                        small: "",
                        "aria-label": _vm.rangeLabels[r] || r,
                        "aria-pressed": r === _vm.range ? "true" : "false"
                      }
                    },
                    [_vm._v(_vm._s(r))]
                  )
                }),
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "vds-metrics__sr-status",
              attrs: {
                "aria-live": "polite"
              }
            },
            [_vm._v(_vm._s(_vm.statusMessage))]
          ),
          !_vm.capable
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    type: "info",
                    border: "left",
                    dense: ""
                  }
                },
                [_vm._v(" Metric history isn't available for this server. ")]
              )
            : _vm.loadingMetrics
            ? _c(
                "div",
                {
                  staticClass: "py-8 text-center"
                },
                [
                  _c("v-progress-circular", {
                    attrs: {
                      indeterminate: "",
                      color: "primary",
                      size: "36",
                      width: "3",
                      "aria-hidden": "true"
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "vds-metrics__loading mt-3 mb-0"
                    },
                    [_vm._v("Loading metrics…")]
                  )
                ],
                1
              )
            : _vm.error
            ? _c(
                "v-alert",
                {
                  staticClass: "mb-0",
                  attrs: {
                    type: "error",
                    border: "left",
                    dense: "",
                    role: "alert"
                  }
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.error.message ||
                          "Metrics are temporarily unavailable."
                      ) +
                      " "
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "mt-2"
                    },
                    [
                      _c(
                        "gg-btn",
                        {
                          staticClass: "error--text",
                          attrs: {
                            small: "",
                            tile: "",
                            color: "white"
                          },
                          on: {
                            click: _vm.loadMetrics
                          }
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                left: "",
                                small: "",
                                "aria-hidden": "true"
                              }
                            },
                            [_vm._v("mdi-refresh")]
                          ),
                          _vm._v("Retry ")
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]
              )
            : _c(
                "v-row",
                _vm._l(_vm.graphs, function(g) {
                  return _c(
                    "v-col",
                    {
                      key: g.key,
                      attrs: {
                        cols: "12",
                        md: "6"
                      }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "vds-graph pa-3"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "d-flex align-center mb-2"
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "vds-graph__title body-2 mr-auto"
                                },
                                [_vm._v(_vm._s(g.title))]
                              ),
                              _c(
                                "span",
                                {
                                  staticClass: "vds-graph__current"
                                },
                                [_vm._v(_vm._s(g.current))]
                              )
                            ]
                          ),
                          g.values.length
                            ? _c(
                                "div",
                                {
                                  staticClass: "vds-graph__chart",
                                  attrs: {
                                    role: "img",
                                    "aria-label": _vm.chartLabel(g)
                                  }
                                },
                                [
                                  _c("v-sparkline", {
                                    attrs: {
                                      value: g.values,
                                      gradient: _vm.gradient,
                                      smooth: 8,
                                      "line-width": 1,
                                      padding: 8,
                                      "auto-draw": !_vm.reduceMotion,
                                      "auto-draw-duration": 350,
                                      "stroke-linecap": "round",
                                      "aria-hidden": "true"
                                    }
                                  })
                                ],
                                1
                              )
                            : _c(
                                "p",
                                {
                                  staticClass:
                                    "vds-graph__empty text-caption mb-0"
                                },
                                [_vm._v("No data points in this range.")]
                              )
                        ]
                      )
                    ]
                  )
                }),
                1
              )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }